import { Box, Grid } from "@material-ui/core";
import { Form } from "@components";
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";
import { Search } from "./search-filters";
import { Actions } from "../../../screens/request/components/actions";

import { createStyles, Theme, WithStyles } from "@material-ui/core/styles";
import { SalesforceRoleDetail } from "../../../screens/dashboard/admin/maintenance/salesforcerole/detail";
import { SalesforceRoleModel } from "@api/types/salesforcerole";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onClickAdd: () => void;
}

export const SalesforceRoleToolbar: React.FC<Props> = ({}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { dispatch } = useContext(TableContext);
  const [] = React.useState<boolean>(false);
  const [] = React.useState(false);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!openModal) {
      // clear form if modal has closed
      form.reset();
    }
  }, [openModal]);

  const form = Form.useManager<SalesforceRoleModel>({
    id: 0,
    roleName: "",
    isActive: false,
    region: "",
  });

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const isShowModal = openModal ? (
    <SalesforceRoleDetail
      form={form}
      open={openModal}
      onCancel={() => setOpenModal(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Role
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Role Name"}
          ></Search>
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
